"use client"

import type { ComponentProps, ElementType, ReactNode } from "react"
import { useRef, useState } from "react"
import { useGSAP } from "@gsap/react"
import cn from "classnames"
import { gsap } from "gsap"

import { SmoothScrollWrapper } from "~/components/elements/SmoothScrollWrapper/SmoothScrollWrapper"
import { usePresence } from "~/components/foundations/AnimatePresence/usePresence"

import s from "./TransitionContainer.module.scss"

type Props = {
  className?: string
  children: ReactNode
} & ComponentProps<ElementType>

export const TransitionContainer = ({ className, children }: Props) => {
  const { isPresent, safeToRemove } = usePresence()

  const wrapperRef = useRef<HTMLDivElement>(null)

  const [isIn, setIsIn] = useState(false)

  useGSAP(
    () => {
      const enterTl = gsap.timeline({
        paused: true,
      })
      const exitTl = gsap.timeline({ paused: true })
      if (isPresent) {
        enterTl.fromTo(
          wrapperRef.current,
          { opacity: 0 },
          {
            opacity: 1,
            duration: 0.5,
          },
        )

        setIsIn(true)
        enterTl.play()
      } else if (!isPresent) {
        exitTl.to(wrapperRef.current, {
          opacity: 0,
          duration: 0.5,
          onComplete: safeToRemove,
        })
        exitTl.play()
      }
    },
    {
      dependencies: [isPresent, safeToRemove],
      scope: wrapperRef,
    },
  )

  return (
    <SmoothScrollWrapper
      isIn={isIn}
      scrollWrapperRef={wrapperRef}
      className={cn(s.contentWrapper, className)}
    >
      {children}
    </SmoothScrollWrapper>
  )
}
